import { helpers } from "vuelidate/lib/validators";

export const phone = helpers.withParams({ type: "phone" }, value => {
  return (
    !helpers.req(value) ||
    /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im.test(value)
  );
});

export const maxsize = limit => {
  return helpers.withParams({ type: "maxsize" }, value => {
    return !helpers.req(value) || (value && value.size / 1024 <= limit);
  });
};

export const filetype = type => {
  return helpers.withParams({ type: "filetype" }, value => {
    return !helpers.req(value) || (value && value.type === type);
  });
};

export const serverError = errors => {
  return helpers.withParams(
    { type: "serverError" },
    value => !helpers.req(value) || !errors || !errors.length
  );
};

export const checked = (checkedValue = true) => {
  return helpers.withParams(
    { type: "checked" },
    value => value === checkedValue
  );
};
